import { createSelector,createSlice } from '@reduxjs/toolkit';
import { fetchUserGroups } from 'common/services/api/UserGroups/UserGroups.thunk';
import { UserGroup } from 'common/types/Entities';
import { createLoadedExtraReducers } from 'common/utils/sliceUtils/entitySliceUtils';
import { filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';
import { sortByProp } from 'common/utils/SortArrayByPropName';

import type { RootState } from '../../app/store';

type UserGroupsSliceState = FilterState & {
    userGroups: UserGroup[],
    loaded: boolean,
};

const initialState: UserGroupsSliceState = {
    userGroups: [],
    loaded: false,
    filters: {
        keywords: [],
    }
};

const userGroupsSlice = createSlice({
    name: 'userGroups',
    initialState,

    reducers: (create) => ({
        ...filterReducers,
        clearUserGroups: create.reducer((state) => {
            state.userGroups = [];
        })
    }),

    extraReducers: builder => {
        createLoadedExtraReducers<UserGroup>(builder, fetchUserGroups, 'userGroups');
    }
});

// eslint-disable-next-line no-restricted-syntax
export default userGroupsSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, clearUserGroups } = userGroupsSlice.actions;
export const selectFilters = (state: RootState) => state.userGroups.filters;
const userGroupsState = (state: RootState) => state.userGroups.userGroups;
export const selectUserGroups = createSelector(userGroupsState, userGroups => {
    return sortByProp('name')(userGroups);
});
export const selectUserGroupsLoading = (state: RootState) => state.userGroups.loaded;
